<template>
  <div id="app">
    <step-transition>
      <component
        :is="currentStep"
        :key="currentStep">
      </component>
    </step-transition>
  </div>
</template>

<script>
import StepTransition from '@shared/components/StepTransition'
import { mapGetters } from 'vuex'
import scrollHelper from '@shared/utils/scrollHelper'

import Intro from './views/Intro'
import VideoStep from './views/VideoStep'
import GapFillHeures from './views/GapFillHeures'
import Outro from './views/Outro'

export default {
  name: 'App',
  components: {
    StepTransition,
    intro: Intro,
    videoStep: VideoStep,
    gapFillHeures: GapFillHeures,
    outro: Outro
  },
  computed: {
    ...mapGetters(['currentStep'])
  },
  mounted () {
    this.$store.dispatch('init')
    scrollHelper.init()
  }
}
</script>

<style lang="scss">
  @import "../shared/styles/globals";
</style>
